import React from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer.jsx'
import WhatsApp from 'components/Whatsapp'

import Banner from './components/Banner'
import Highlights from './components/Highlights'
import OurEdge from './components/OurEdge'
import OurServices from './components/OurServices'
import AboutUs from './components/AboutUs'

import background from 'assets/images/background.png'

function Home() {
  return (
    <main
      className='overflow-x-hidden bg-cover bg-fixed bg-center'
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <Header />
      <Banner
        title='Segurança e Credibilidade!'
        description='Oferecemos soluções financeiras ágeis e personalizadas para garantir sua tranquilidade. Confie em quem é líder no mercado!'
        buttonText='Fale Conosco'
        buttonLink='https://api.whatsapp.com/send?phone=5543988634741&text=Ol%C3%A1%2C%20Vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20seus%20servi%C3%A7os.'
      />
      <Highlights />
      <OurEdge />
      <OurServices />
      <AboutUs />
      <Footer />
      {/* <WhatsApp /> */}
    </main>
  )
}

export default Home
